import {ApiEventRequest} from '../../../models/requests/apiEvent.request';
import axios from '../../../utilities/axios';
import {Helpers} from "../../../utilities/helpers";

export const apiEventRequest = async (request: ApiEventRequest): Promise<void> => {
  try {
    if (request.userId !== 0) {
      if (Helpers.isEnvProd()) {
        const response = await axios.post<void>(
          `${process.env.REACT_APP_BASE_URL_API_EVENT}/`,
          request,
        );
        return response.data;
      } else {
        console.log(`>> API EVENT: ${JSON.stringify(request)}`);
      }
    }
  } catch (error) {
    throw error;
  }
};
